import React from 'react';
import BriefTag from './BriefTag';
import styles from './CampaignHashtagChips.module.scss';

interface CampaignHashtagChipsProps {
  keywords: string[];
  testID?: string;
}

function CampaignHashtagChips({
  keywords,
  testID = 'campaign-hashtag-chips',
}: CampaignHashtagChipsProps) {
  if (!keywords.length) {
    return null;
  }

  return (
    <div className={styles.chips} data-testid={testID}>
      {keywords.map((keyword) => (
        <BriefTag key={keyword} label={keyword} prefix="#" />
      ))}
    </div>
  );
}

export default CampaignHashtagChips;
